<db-ecommerce-view-header [currentPage]="pageData?.header.currentPage"
                          [previousPath]="pageData?.header.previousPath"
                          [previewsPage]="pageData?.header.previousPage"
                          [website]="website"
                          [orderId]="orderId"
                          [orderHasRefunds]="orderHasRefunds"
                          [fullRefunded]="fullRefunded"
                          [orderHasTestPayment]="orderHasTestPayment"
                          (showRefundSection)="handleRefundSectionToggle($event)">
</db-ecommerce-view-header>
<db-ecommerce-view-stats *ngIf="showStats" [stat]="pageData?.stats">
</db-ecommerce-view-stats>
<ng-content select="[address]"></ng-content>
<section class="item-wrapper" *ngIf="!loading">
  <section class="main-container">
    <db-ecommerce-view-body
      [heads]="tableHeads"
      [headerGreedStyle]="headerGreedStyle"
      [headerGreedStyleRefund]="headerGreedStyleRefund">
      <ng-content></ng-content>
    </db-ecommerce-view-body>
  </section>
  <section class="sidebar" *ngIf="showSidebar">
    <db-ecommerce-view-sidebar [sidebar]="pageData?.sidebar">
    </db-ecommerce-view-sidebar>
  </section>
</section>
<db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
